import request from "superagent";
import env from "../constants/env";
import { refreshCredentials } from "../utils/securityUtil";
import { getJwtToken } from "./user";
import { showError } from "./alertActions";
import { getAppBaseUrl } from "../utils/utils";
import { isImpersonationLink, opensOnAnotherOrigin } from "../utils/impersonationLink";
import { logoutUser } from "./portalActions";

const HOSTED_UI_SESSION_KEY = "amplify-signin-with-hostedUI";

// Creates an impersonation link for the administrator to copy or open from the Dev Info panel (utils/impersonationLink.js).
export async function createImpersonationLink(orgId, cognitoUserSubId) {
	try {
		const response = await generateMagicLink(orgId, cognitoUserSubId);
		const magicLink = response && response.magicLink;
		if (!isImpersonationLink(magicLink)) {
			throw new Error("The service did not return a sign-in link");
		}
		return magicLink;
	} catch (e) {
		showError("Error", "Impersonate user failed: " + (e && e.message ? e.message : e));
		return null;
	}
}

// A link for another origin opens in a new tab and this session stays signed in; a link for this origin replaces this
// session, which is ended first. Amplify ends a hosted-UI (SSO) session by redirecting to the identity provider, which
// would swallow the navigation, so such a session is only ended locally.
export async function openImpersonationLink(magicLink) {
	if (opensOnAnotherOrigin(magicLink)) {
		window.open(magicLink, "_blank", "noopener,noreferrer");
		return;
	}
	try {
		if (isHostedUiSession()) {
			window.localStorage.setItem(HOSTED_UI_SESSION_KEY, "false");
		}
		await logoutUser(false);
		window.location.href = magicLink;
	} catch (e) {
		showError("Error", "Impersonate user failed: " + e.message);
	}
}

function isHostedUiSession() {
	try {
		return window.localStorage.getItem(HOSTED_UI_SESSION_KEY) === "true";
	} catch (e) {
		return false;
	}
}

export async function generateMagicLink(orgId, cognitoUserSubId) {

	const payload = {
		orgId,
		cognitoUserSubId,
		baseUrl: getAppBaseUrl()
	};

	return new Promise((resolve, reject) => {
		refreshCredentials().then(() => {
			request.post(`${env.apiGateway.baseUrl}${env.apiGateway.endpoints.admin.ml.generateMagicLink}`)
				.set("Authorization", getJwtToken())
				.send(payload)
				.then((res) => {
					resolve(res.body);
				}).catch(err => {
					reject(err);
				});
		}).catch(reject);
	});
}
